import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {PlanModelService} from '../../common/service/plan-model.service';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {NgClass} from '@angular/common';
import {NlrHasPermissionsPipe} from '../../common/pipe/nlr-has-permissions.pipe';
import {NlrPermissionsDisabledPipe} from '../../common/pipe/nlr-permissions-disabled-pipe';
import {UiConfigurationService} from '../../common/service/ui-configuration.service';

@Component({
    selector: 'nlr-crown-state-land',
    imports: [FormsModule, NgClass, NlrHasPermissionsPipe, NlrPermissionsDisabledPipe],
    templateUrl: './crown-state-land.component.html',
    styleUrl: './crown-state-land.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class CrownStateLandComponent implements OnInit, OnDestroy {
    @Input() submitted: boolean;

    title = 'Crown state land';

    yesNoOptions = [
        {value: true, displayValue: 'Yes'},
        {value: false, displayValue: 'No'}
    ];

    get readonly() {
        return this.planModelService.readonly;
    }

    constructor(
        private planModelService: PlanModelService,
        private uiConfigurationService: UiConfigurationService
    ) {}

    ngOnInit() {
        if (!this.getModel().crownStateLand || Object.keys(this.getModel().crownStateLand).length === 0) {
            this.getModel().crownStateLand = {
                dolInstructedPlan: undefined,
                dolAdvisedPlan: undefined,
                dolFileNumber: undefined,
                hasNoticeOfIntentionToTake: undefined
            };
        }
    }

    ngOnDestroy() {
        const infoUiGroup = this.uiConfigurationService.getInfoUiGroup();
        if (!infoUiGroup?.crownStateLandDisplay) {
            this.getModel().crownStateLand = undefined;
        }
    }

    dolInstructedPlanChanged() {
        const crownStateLand = this.getCrownStateLand();
        if (!crownStateLand.dolInstructedPlan) {
            Object.assign(crownStateLand, {
                dolAdvisedPlan: false,
                dolFileNumber: undefined,
                hasNoticeOfIntentionToTake: false
            });
        }
    }

    getCrownStateLand() {
        return this.getModel().crownStateLand;
    }

    private getModel() {
        return this.planModelService.getModel();
    }
}
